import getCountryCodeByLocale from "./getCountryCodeByLocale";

const getIsDeliveryDomestic = (defaultLocale: string, countryFrom: string, countryTo: string): boolean => {
  if (countryFrom !== countryTo) {
    return false;
  }
  const domesticCountryCode = getCountryCodeByLocale(defaultLocale);

  return countryFrom === domesticCountryCode;
};
export default getIsDeliveryDomestic;
